import React from 'react';
import Navbar from './Navbar/Navbar.jsx';
import Content from './Content.jsx';
import { useIsLogin } from '../../hooks/useIsLogin.js';
import { Navigate } from 'react-router-dom';
import Waiting from '../Waiting.jsx';

const MainLayout = () => {
    const [isLogin, isLoading] = useIsLogin();

    return isLoading ? (
       <Waiting />
    ) : isLogin ? (
        <>
            <Navbar />
            <Content />
        </>
    ) : (
        <Navigate to="/auth/login" />
    );
}

export default MainLayout;
